export function renderTopbarNavigation({
  mainContainer,
  administrationButton,
  administrationItems,
  items = [],
  activeId = "",
  onNavigate = null
}) {
  const source = Array.isArray(items) ? items : [];
  const main = source.filter(item => item.group !== "administration");
  const administration = source.filter(item => item.group === "administration");

  const makeItem = (item, className) => {
    const element = item.href ? document.createElement("a") : document.createElement("button");
    if (!item.href) element.type = "button";
    element.className = className;
    element.textContent = item.label;
    element.dataset.navId = item.id;
    if (item.tabTarget) element.dataset.tabTarget = item.tabTarget;
    if (item.href) element.href = window.PORTAL_BASE?.url(item.href) || item.href;
    if (item.id === activeId) element.classList.add("active");
    if (!item.href && typeof onNavigate === "function") {
      element.addEventListener("click", () => onNavigate(item.id, element));
    }
    return element;
  };

  mainContainer?.replaceChildren(...main.map(item => makeItem(item, "portal-tab")));
  administrationItems?.replaceChildren(...administration.map(item => makeItem(item, "admin-nav-menu-item")));

  if (administrationButton) {
    administrationButton.hidden = administration.length === 0;
    administrationButton.classList.toggle("active", administration.some(item => item.id === activeId));
  }

  return { mainCount: main.length, administrationCount: administration.length };
}
